module.exports = __webpack_public_path__ + "img/img_fan@2x.83a47e23.png";